class PlayerService {
  currentPlayer: { stop: (byUser?: boolean) => Promise<void>; stopped$?: { actual: boolean } } | null = null;

  async stopCurrentPlayer() {
    const player = this.currentPlayer;
    if (!player?.stop) return;

    try {
      await player.stop(false);
    } catch {
    }

    if (this.currentPlayer === player) {
      this.currentPlayer = null;
    }
  }
}

export const playerService = new PlayerService();
